


























import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({})
export default class CDContributors extends Vue {
  @Prop({type: Number, default: 0})
  value!: number

  formatValue(value: number) {
    if (value === null) return '0'

    return value.toLocaleString('eng-us')
  }
}
